import { defineComponents } from '@contentful/experiences-sdk-react';

import { buttonDefinition } from '@/components/ui/button/buttonDefinition';
import { Button } from '@/components/ui/button/buttonExperience';

// import { LinkExperience } from '@/components/ui/link/linkExperience';
// import { linkExperienceDefinition } from '@/components/ui/link/linkExperienceDefinition';

import { breadcrumbDefinition } from '@/components/ui/breadcrumb/breadcrumbDefinition';
import { Breadcrumb } from '@/components/ui/breadcrumb/breadcrumbExperience';

import { Heading } from '@/components/basic/typography/heading';
import { headingDefinition } from '@/components/basic/typography/headingDefinition';

import { Subheading } from '@/components/basic/typography/subheading';
import { subheadingDefinition } from '@/components/basic/typography/subheadingDefinition';

import { RichText } from '@/components/basic/typography/richText';
import { richTextDefinition } from '@/components/basic/typography/richTextDefitition';

import { htmlDefinition } from '@/components/basic/html/htmlDefinition';
import { HTMLExperience } from '@/components/basic/html/htmlExperience';

import { Slide } from '@/components/experience/slider/Slide';
import { slideDefinition } from '@/components/experience/slider/slideDefinition';

import { Slider } from '@/components/experience/slider/Slider';
import { sliderDefinition } from '@/components/experience/slider/sliderDefinition';

import ExternalVideo from '@/components/experience/externalVideo/ExternalVideo';
import externalVideoDefinition from '@/components/experience/externalVideo/externalVideoDefinition';

import { MediaExperience } from '@/components/experience/media/MediaExperience';
import { mediaDefinition } from '@/components/experience/media/mediaDefinition';

import { accordionDefinition } from '@/components/ui/accordion/accordionDefinition';
import { AccordionExperience } from '@/components/ui/accordion/accordionExperience';

import { accordionItemDefinition } from '@/components/ui/accordion/accordionItemDefinition';
import { AccordionItemExperience } from '@/components/ui/accordion/accordionItemExperience';

import { AnchorTarget } from '@/components/basic/anchorTarget/anchorTarget';
import { anchorTargetDefinition } from '@/components/basic/anchorTarget/anchorTargetDefinition';

import { badgeDefinition } from '@/components/ui/badge/badgeDefinition';
import { BadgeExperience } from '@/components/ui/badge/badgeExperience';
import { MarketoFormExperience } from '@/components/ui/marketo-form/marketoFormExperience';
import { marketoFormExperienceDefinition } from '@/components/ui/marketo-form/marketoFormExperienceDefinition';

import { listingDefinition } from '@/components/experience/listing/listingDefinition';
import { ListingExperience } from '@/components/experience/listing/ListingExperience';

import { ScrollingShowcaseItem } from '@/components/experience/scrollingShowcase/ScrollingShowcaseItem';
import { scrollingShowcaseItemDefinition } from '@/components/experience/scrollingShowcase/scrollingShowcaseItemDefinition';
import { ScrollingShowcaseWrapper } from '@/components/experience/scrollingShowcase/ScrollingShowcaseWrapper';
import { scrollingShowcaseWrapperDefinition } from '@/components/experience/scrollingShowcase/scrollingShowcaseWrapperDefinition';

import { insightCardDefinition } from '@/components/section/insights-section/insightCardDefinition';
import { InsightCardExperience } from '@/components/section/insights-section/insightCardExperience';
import { insightsSectionDefinition } from '@/components/section/insights-section/insightsSectionDefinition';
import { InsightsSectionExperience } from '@/components/section/insights-section/insightsSectionExperience';

import { tabGroupDefinition } from '@/components/section/tab-section/tabGroupDefinition';
import { TabGroupExperience } from '@/components/section/tab-section/tabGroupExperience';
import { tabSectionDefinition } from '@/components/section/tab-section/tabSectionDefinition';
import { TabSectionExperience } from '@/components/section/tab-section/tabSectionExperience';
import { tabSectionItemDefinition } from '@/components/section/tab-section/tabSectionItemDefinition';
import { TabSectionItemExperience } from '@/components/section/tab-section/tabSectionItemExperience';

export function registerExperienceComponents() {
  defineComponents([
    {
      component: Button,
      definition: buttonDefinition,
    },
    // {
    //   component: LinkExperience,
    //   definition: linkExperienceDefinition,
    // },
    {
      component: Breadcrumb,
      definition: breadcrumbDefinition,
    },
    {
      component: AnchorTarget,
      definition: anchorTargetDefinition,
    },
    {
      component: Heading,
      definition: headingDefinition,
    },
    {
      component: Subheading,
      definition: subheadingDefinition,
    },
    {
      component: RichText,
      definition: richTextDefinition,
    },
    {
      component: HTMLExperience,
      definition: htmlDefinition,
    },
    {
      component: Slide,
      definition: slideDefinition,
    },
    {
      component: Slider,
      definition: sliderDefinition,
    },
    {
      component: ExternalVideo,
      definition: externalVideoDefinition,
    },
    {
      component: MediaExperience,
      definition: mediaDefinition,
    },
    {
      component: AccordionExperience,
      definition: accordionDefinition,
    },
    {
      component: AccordionItemExperience,
      definition: accordionItemDefinition,
    },
    {
      component: BadgeExperience,
      definition: badgeDefinition,
    },
    {
      component: MarketoFormExperience,
      definition: marketoFormExperienceDefinition,
    },
    {
      component: ListingExperience,
      definition: listingDefinition,
    },
    {
      component: ScrollingShowcaseWrapper,
      definition: scrollingShowcaseWrapperDefinition,
    },
    {
      component: ScrollingShowcaseItem,
      definition: scrollingShowcaseItemDefinition,
    },
    {
      component: InsightsSectionExperience,
      definition: insightsSectionDefinition,
    },
    {
      component: InsightCardExperience,
      definition: insightCardDefinition,
    },
    {
      component: TabSectionExperience,
      definition: tabSectionDefinition,
    },
    {
      component: TabGroupExperience,
      definition: tabGroupDefinition,
    },
    {
      component: TabSectionItemExperience,
      definition: tabSectionItemDefinition,
    },
  ]);
}
